export default __webpack_public_path__ + "static/media/neverra.7023aff2.ico";